export enum SearchActionTypes {
  SET_VALUE,
  SET_SUGGESTIONS,
  RESET
}
